import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, User, Server, Mail, FileText, Scale } from 'lucide-react';

const MentionsLegalesPage = () => {
    // Scroll to top on page load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-slate-50">
            {/* Header */}
            <header className="bg-white border-b border-slate-200">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <Link to="/" className="inline-flex items-center text-slate-600 hover:text-slate-900">
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Retour à l'accueil
                    </Link>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center">
                            <Scale className="w-7 h-7 text-blue-600" />
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold text-slate-900">Mentions Légales</h1>
                            <p className="text-slate-500">Conformément à l'article 6 de la loi n° 2004-575 du 21 juin 2004</p>
                        </div>
                    </div>

                    <div className="space-y-8">
                        {/* Éditeur du site */}
                        <section>
                            <div className="flex items-center gap-3 mb-4">
                                <Building2 className="w-5 h-5 text-blue-600" />
                                <h2 className="text-xl font-bold text-slate-900">1. Éditeur du site</h2>
                            </div>
                            <div className="bg-slate-50 rounded-xl p-6 space-y-3">
                                <p className="text-slate-700">
                                    Le site <strong>PHONEB2B</strong> (ci-après « le Site ») est édité par :
                                </p>
                                <div className="grid sm:grid-cols-2 gap-4 text-sm">
                                    <div>
                                        <p className="text-slate-500">Raison sociale</p>
                                        <p className="font-medium text-slate-900">ECO MOBILE SOLUTION</p>
                                    </div>
                                    <div>
                                        <p className="text-slate-500">Forme juridique</p>
                                        <p className="font-medium text-slate-900">Société par Actions Simplifiée (SAS) à associé unique</p>
                                    </div>
                                    <div>
                                        <p className="text-slate-500">Capital social</p>
                                        <p className="font-medium text-slate-900">1 000,00 €</p>
                                    </div>
                                    <div>
                                        <p className="text-slate-500">SIREN</p>
                                        <p className="font-medium text-slate-900">982 341 869</p>
                                    </div>
                                    <div>
                                        <p className="text-slate-500">RCS</p>
                                        <p className="font-medium text-slate-900">Valenciennes B 982 341 869</p>
                                    </div>
                                    <div>
                                        <p className="text-slate-500">N° TVA Intracommunautaire</p>
                                        <p className="font-medium text-slate-900">FR40 982 341 869</p>
                                    </div>
                                    <div className="sm:col-span-2">
                                        <p className="text-slate-500">Siège social</p>
                                        <p className="font-medium text-slate-900">
                                            ZI N2 CD 70 Le Biplan, Route d'Hérin<br />
                                            59220 Rouvignies, France
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Directeur de publication */}
                        <section>
                            <div className="flex items-center gap-3 mb-4">
                                <User className="w-5 h-5 text-blue-600" />
                                <h2 className="text-xl font-bold text-slate-900">2. Directeur de la publication</h2>
                            </div>
                            <div className="bg-slate-50 rounded-xl p-6">
                                <p className="text-slate-700">
                                    Le Directeur de la publication du Site est <strong>M. Safir Hichem</strong>, 
                                    en qualité de Président de la société ECO MOBILE SOLUTION.
                                </p>
                            </div>
                        </section>

                        {/* Contact */}
                        <section>
                            <div className="flex items-center gap-3 mb-4">
                                <Mail className="w-5 h-5 text-blue-600" />
                                <h2 className="text-xl font-bold text-slate-900">3. Contact</h2>
                            </div>
                            <div className="bg-slate-50 rounded-xl p-6 space-y-2">
                                <p className="text-slate-700">
                                    Pour toute question ou réclamation concernant le Site, vous pouvez nous contacter :
                                </p>
                                <p className="text-slate-700">
                                    <strong>Email :</strong>{' '}
                                    <a href="mailto:welcome@phoneb2b.com" className="text-blue-600 hover:underline">
                                        welcome@phoneb2b.com
                                    </a>
                                </p>
                                <p className="text-slate-700">
                                    <strong>Adresse postale :</strong> ZI N2 CD 70 Le Biplan, Route d'Hérin, 59220 Rouvignies, France
                                </p>
                            </div>
                        </section>

                        {/* Hébergement */}
                        <section>
                            <div className="flex items-center gap-3 mb-4">
                                <Server className="w-5 h-5 text-blue-600" />
                                <h2 className="text-xl font-bold text-slate-900">4. Hébergement</h2>
                            </div>
                            <div className="bg-slate-50 rounded-xl p-6 space-y-2">
                                <p className="text-slate-700">
                                    Le Site est hébergé par :
                                </p>
                                <div className="text-sm">
                                    <p className="font-medium text-slate-900">Amazon Web Services (AWS)</p>
                                    <p className="text-slate-600">Amazon Web Services EMEA SARL</p>
                                    <p className="text-slate-600">38 Avenue John F. Kennedy</p>
                                    <p className="text-slate-600">L-1855 Luxembourg</p>
                                    <p className="text-slate-600 mt-2">
                                        <a href="https://aws.amazon.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                            https://aws.amazon.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* Propriété intellectuelle */}
                        <section>
                            <div className="flex items-center gap-3 mb-4">
                                <FileText className="w-5 h-5 text-blue-600" />
                                <h2 className="text-xl font-bold text-slate-900">5. Propriété intellectuelle</h2>
                            </div>
                            <div className="bg-slate-50 rounded-xl p-6 space-y-4 text-slate-700">
                                <p>
                                    L'ensemble du contenu du Site (textes, images, graphismes, logo, icônes, sons, 
                                    logiciels, etc.) est la propriété exclusive de ECO MOBILE SOLUTION ou de ses 
                                    partenaires et est protégé par les lois françaises et internationales relatives 
                                    à la propriété intellectuelle.
                                </p>
                                <p>
                                    Toute reproduction, représentation, modification, publication, adaptation de tout 
                                    ou partie des éléments du Site, quel que soit le moyen ou le procédé utilisé, est 
                                    interdite, sauf autorisation écrite préalable de ECO MOBILE SOLUTION.
                                </p>
                                <p>
                                    Toute exploitation non autorisée du Site ou de l'un quelconque des éléments qu'il 
                                    contient sera considérée comme constitutive d'une contrefaçon et poursuivie 
                                    conformément aux dispositions des articles L.335-2 et suivants du Code de la 
                                    Propriété Intellectuelle.
                                </p>
                            </div>
                        </section>

                        {/* Limitation de responsabilité */}
                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Limitation de responsabilité</h2>
                            <div className="bg-slate-50 rounded-xl p-6 space-y-4 text-slate-700">
                                <p>
                                    ECO MOBILE SOLUTION s'efforce d'assurer au mieux de ses possibilités l'exactitude 
                                    et la mise à jour des informations diffusées sur le Site. Toutefois, ECO MOBILE 
                                    SOLUTION ne peut garantir l'exactitude, la précision ou l'exhaustivité des 
                                    informations mises à disposition sur le Site.
                                </p>
                                <p>
                                    En conséquence, ECO MOBILE SOLUTION décline toute responsabilité pour toute 
                                    imprécision, inexactitude ou omission portant sur des informations disponibles 
                                    sur le Site.
                                </p>
                                <p>
                                    ECO MOBILE SOLUTION ne pourra être tenue responsable des dommages directs ou 
                                    indirects causés au matériel de l'utilisateur lors de l'accès au Site, résultant 
                                    soit de l'utilisation d'un matériel ne répondant pas aux spécifications techniques 
                                    requises, soit de l'apparition d'un bug ou d'une incompatibilité.
                                </p>
                            </div>
                        </section>

                        {/* Droit applicable */}
                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Droit applicable et juridiction compétente</h2>
                            <div className="bg-slate-50 rounded-xl p-6 space-y-4 text-slate-700">
                                <p>
                                    Les présentes mentions légales sont régies par le droit français. En cas de 
                                    litige, et après échec de toute tentative de recherche d'une solution amiable, 
                                    les tribunaux français seront seuls compétents pour connaître de ce litige.
                                </p>
                            </div>
                        </section>

                        {/* Liens */}
                        <section className="border-t border-slate-200 pt-6">
                            <h2 className="text-lg font-semibold text-slate-900 mb-4">Documents complémentaires</h2>
                            <div className="flex flex-wrap gap-4">
                                <Link 
                                    to="/cgv" 
                                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium"
                                >
                                    <FileText className="w-4 h-4" />
                                    Conditions Générales de Vente
                                </Link>
                                <Link 
                                    to="/privacy" 
                                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium"
                                >
                                    <FileText className="w-4 h-4" />
                                    Confidentialité & Cookies
                                </Link>
                            </div>
                        </section>

                        {/* Dernière mise à jour */}
                        <p className="text-center text-sm text-slate-400 pt-4">
                            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                        </p>

                        {/* Retour à l'accueil */}
                        <div className="mt-8 text-center">
                            <Link 
                                to="/" 
                                onClick={() => window.scrollTo(0, 0)}
                                className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-xl hover:bg-slate-800 transition-colors font-medium"
                            >
                                <ArrowLeft className="w-4 h-4" />
                                Retour à l'accueil
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default MentionsLegalesPage;
